import Route from '@ember/routing/route';

export default class PaymentLinkExpiredRoute extends Route {}
